<template>
  <div class="top-chart">
    <p class="top-chart__title">
      {{ label }}{{ historical ? ", " + lastUpdateRefined : "" }}
    </p>
    <div
      :class="['top-chart__container', { historical: historical }]"
      id="chart-container"
    >
      <div
        v-for="(element, index) in dataArray"
        :key="historical ? element.TYPE : element.label"
        :id="'row' + index"
        :class="[
          'top-chart__container__row',
          {
            highlighted:
              index === scatterIndex || hoveredStacked === element.TYPE,
          },
          {
            notHighlighted:
              (index !== scatterIndex && scatterIndex !== null) ||
              (hoveredStacked !== element.TYPE && hoveredStacked !== null),
          },
        ]"
        @mouseover="
          element.TYPE
            ? setHoveredStacked(element.TYPE)
            : setScatterIndex(index, element.TYPE)
        "
        @mouseout="
          element.TYPE ? setHoveredStacked(null) : setScatterIndex(null)
        "
      >
        <p class="top-chart__container__row__size" v-if="historical">
          {{
            historical ? $n(element.PERC) + "%" : $n(element.size.toFixed(0))
          }}
        </p>
        <p class="top-chart__container__row__label">
          {{ historical ? element.TYPE : element.label }}
        </p>
      </div>
    </div>
    <button class="top-chart__scroll" v-if="!historical" @click="scroll">
      <p class="top-chart__scroll__label">Scroll down</p>
      <svgicon
        name="arrow-down"
        width="1rem"
        height="1rem"
        color="var(--white_04)"
      ></svgicon>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TopChart",
  props: {
    dataArray: { type: Array },
    label: { type: String },
    historical: { type: Boolean },
  },
  data() {
    return { scrollHeight: 0 };
  },
  watch: {
    geoArea() {
      this.scrollHeight = 0;
      const container = document.getElementById("chart-container");
      container.scrollTo({ top: 0 });
    },
  },
  computed: {
    lastUpdateRefined() {
      return +this.lastUpdate - 1;
    },
    ...mapGetters({
      geoArea: "ui/geoArea",
      scatterIndex: "ui/scatterIndex",
      hoveredStacked: "ui/hoveredStacked",
      lastUpdate: "data/getLastUpdated",
    }),
  },
  methods: {
    scroll() {
      const container = document.getElementById("chart-container");
      this.scrollHeight = this.scrollHeight + container.clientHeight;
      container.scroll({ top: this.scrollHeight, behavior: "smooth" });
    },
    ...mapActions({
      setScatterIndex: "ui/setScatterIndex",
      setHoveredStacked: "ui/setHoveredStacked",
    }),
  },
};
</script>

<style lang="scss" scoped>
.top-chart {
  width: toRem(220);
  color: white;
  @include dida-S;
  .top-chart__container {
    height: calc(
      100vh - $button-drill-height-open - $switch-drill-height -
        $filter-drill-height - $title-drill-height -
        ($row-info-drill-height * 2)
    );
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    &.historical {
      height: calc(
        100vh - $button-drill-height-open - $switch-drill-height -
          $filter-drill-height - $title-drill-height - $row-info-drill-height
      );
    }

    &__row {
      min-height: toRem(49);
      height: 100%;
      padding: 0px 0px 0px 30px;
      flex-grow: 1;
      border: 1px solid $white-01;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      border-top: none;
      background-color: rgba(255, 255, 255, 0.05);
      overflow: hidden;
      transition: background-color 0.3s ease;

      &:last-of-type {
        border-bottom: none;
      }

      &.highlighted {
        border-top: 1px solid $white-01;
        background-color: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
      }

      &.notHighlighted {
        background-color: rgba(255, 255, 255, 0.02);
        border-top-color: rgba(255, 255, 255, 0.02);
        border-bottom-color: rgba(255, 255, 255, 0.02);
        .top-chart__container__row__size {
          opacity: 0.2;
        }
        .top-chart__container__row__label {
          opacity: 0.2;
        }
      }

      &__size {
        color: var(--primary-yellow);
        transition: opacity 0.3s ease;
        @include number-S;
      }

      &__label {
        margin-top: toRem(4);
        transition: opacity 0.3s ease;
        white-space: nowrap;
        @include dida-S;
      }
    }
  }

  &__title {
    height: $row-info-drill-height;
    line-height: toRem(35);
    padding-left: toRem(25);
    border-left: 1px solid $white-01;
    border-bottom: 1px solid $white-01;
  }

  &__scroll {
    height: $row-info-drill-height;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white-04;
    border: 1px solid $white-01;

    &__label {
      margin-right: toRem(7);
    }
  }
}
</style>
